import i18n from 'translations/i18n';
import {
  IAccount,
  ProgressTrackerGroups,
  ProgressTrackerStages,
} from 'services/account';
import {
  findByGroupAndStage,
  getLatestStatus,
} from 'helpers/progressTracker';

export const initialState = () => ({
  rightSignatureURL: '',
  steps: {
    [ProgressTrackerStages.BankSelection]: {
      data: {},
      updatedAt: null,
      status: null,
      label: i18n.t('progressTracker.bankSetup.bankSelection'),
    },
    [ProgressTrackerStages.DocumentSigning]: {
      data: {},
      updatedAt: null,
      status: null,
      label: i18n.t('progressTracker.bankSetup.documentSigning'),
    },
  },
});

export const initialStateBIB = () => ({
  rightSignatureURL: '',
  steps: {
    [ProgressTrackerStages.BankSelection]: {
      data: {},
      updatedAt: null,
      status: null,
      label: i18n.t('progressTracker.bankSetup.bankSelection'),
    },
    [ProgressTrackerStages.BankInformation]: {
      data: {},
      updatedAt: null,
      status: null,
      label: i18n.t('Bank Information'),
    },
  },
});

export const reducer = (
  state: any,
  action: { type: ProgressTrackerStages | string; value: IAccount },
) => {
  switch (action.type) {
    case ProgressTrackerStages.BankSelection: {
      const data = findByGroupAndStage(action.value.progress, {
        group: ProgressTrackerGroups.FormCompletion,
        stage: ProgressTrackerStages.BankSelection,
      });
      return {
        ...state,
        steps: {
          ...state.steps,
          [ProgressTrackerStages.BankSelection]: {
            ...state.steps[ProgressTrackerStages.BankSelection],
            data,
            ...getLatestStatus(data?.status),
          },
        },
      };
    }
    case ProgressTrackerStages.BankInformation: {
      const data = findByGroupAndStage(action.value.progress, {
        group: ProgressTrackerGroups.FormCompletion,
        stage: ProgressTrackerStages.BankInformation,
      });
      return {
        ...state,
        steps: {
          ...state.steps,
          [ProgressTrackerStages.BankInformation]: {
            ...state.steps[ProgressTrackerStages.BankInformation],
            data,
            ...getLatestStatus(data?.status),
          },
        },
      };
    }
    case 'updateRightSignature': {
      return {
        ...state,
        rightSignatureURL: action.value.rightSignatureURL
      }
    }
    default:
      return state;
  }
};
